import { render, staticRenderFns } from "./expertiseDetail.vue?vue&type=template&id=7934bca3&"
import script from "./expertiseDetail.vue?vue&type=script&lang=js&"
export * from "./expertiseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports